import React from "react";
import { useSite } from "@/context/SiteContext";

export default function Gallery() {
  const { gallery } = useSite();

  if (!gallery || gallery.length === 0) return null;

  // Bento-ish varying sizes
  const spans = ["md:col-span-2 md:row-span-2", "", "", "md:col-span-2", "", ""];

  return (
    <section
      data-testid="gallery-section"
      id="gallery"
      className="bg-neutral-950 py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="overline text-[#DC2626]">Recent Projects</span>
            <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold uppercase leading-tight tracking-tight text-white">
              Real work. <span className="text-[#DC2626]">Real results.</span>
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md">
            Every project is built with pride. Browse a selection of kitchens, baths,
            basements &amp; full renovations we&apos;ve completed for Chicagoland homeowners.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[220px] gap-3">
          {gallery.slice(0, 12).map((g, i) => (
            <div
              key={g.id || i}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden group border border-neutral-800 ${spans[i % spans.length]}`}
            >
              <img
                src={g.url}
                alt={g.caption || "Project photo"}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-90" aria-hidden />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                {g.category && (
                  <span className="inline-block bg-[#DC2626] text-white font-heading uppercase text-[10px] tracking-widest px-2 py-1 mb-2">
                    {g.category}
                  </span>
                )}
                {g.caption && (
                  <p className="text-white text-sm font-medium">{g.caption}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
